// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import data_control from "../../../../../engines/libs/data_control";
import LotteryBaseLayer from "../common/LotteryBaseLayer";
import { MahjongDataManage } from "./data/MahjongDataManage";
import { MahjongKind } from "./data/MahjongKind";
import MahjongItemBase from "./MahjongItemBase";
import MahjongItemCom from "./MahjongItemCom";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MahjongLayer extends LotteryBaseLayer {

	@property({ type: cc.Label, displayName:'' })
	labelHaiDiDouble: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeCombinationLayout: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeCardTypeLayout: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelCardType: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeReferLayout2: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeReferLayout1: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelAwardDouble: cc.Label = null;

    @property(cc.Prefab)
    nodeItemComPrefab : cc.Prefab = null;

    /** 牌型数据 */
    private cardData: MahjongKind.CardTypeData = null;
    private cardType: MahjongKind.CardType = null;

    /** 参照区是否已显示 */
    private bReferAreaShow = false;

    // onLoad () {}

    start () {
        super.start();

        let ctd = MahjongKind.CardTypeInfoArr[MahjongKind.CardType.HAI_DI_LAO];
        this.labelHaiDiDouble.string = '海\n底\n' + ctd.multipe + '\n倍';
        this.labelCardType.string = '';
        
        this.resetData();
    }

    // update (dt) {}

    resetData() {
        this.bReferAreaShow = false;
        super.resetData();

        this.getCardTypeData();

        this.resetReferArea();
        this.resetCombinationArea();
    }

    /**
     * 获得牌型数据
     * @returns 
     */
    getCardTypeData() {
        let len = MahjongKind.CardTypeProb.length;
        let randomV = data_control.randomNum(0, 1);
        let prob = 0;
        let cardType = MahjongKind.CardType.DUI_DUI_HU;
        for (let i = 0; i < len; i++) {
            let data = MahjongKind.CardTypeProb[i];
            prob += data.prob;
            if (randomV <= prob) {
                let idx = data_control.randomNumInt(0, data.cardType.length-1);
                cardType = data.cardType[idx];
                break;
            }
        }
        this.cardType = cardType;
        let cardData = MahjongDataManage.generateCardType(cardType);
        this.cardData = cardData;

        this.cardData.card.sort((a, b)=> a-b);
        return cardData;
    }

    /**
     * 参照区
     */
    resetReferArea(){
        this.nodeReferLayout1.removeAllChildren();
        this.nodeReferLayout2.removeAllChildren();
        // 牌
        const cardCount1 = 7;
        for (let i = 0; i < cardCount1; i++) {
            let card = this.cardData.card[i];
            this.generateBaseCard(card, this.nodeReferLayout1);
        }
        for (let i = cardCount1; i < this.cardData.card.length; i++) {
            let card = this.cardData.card[i];
            this.generateBaseCard(card, this.nodeReferLayout2);
        }

        // 牌型
        let cardTypeData = MahjongKind.CardTypeInfoArr[this.cardType];
        this.labelCardType.string = cardTypeData.name;
        this.labelAwardDouble.string = cardTypeData.multipe + '倍';
    }

    /**
     * 组合区
     */
    resetCombinationArea() {
        this.nodeCombinationLayout.removeAllChildren();

        const normalCount = 7;
        // 是否必中
        let bInfallible = false;
        for (let i = 0; i < normalCount; i++) {
            let idx = data_control.randomNumInt(1, MahjongKind.WinProb.length-1);
            let winPropInfo = MahjongKind.WinProb[idx];

            let prob = winPropInfo.prob;
            if (bInfallible) {
                prob = 1;
            }
            let card = 0;
            let bWin = false;
            // 中奖
            if (data_control.isHitProbability(prob)) {
                bWin = true;
                card = data_control.getRandArrItem(this.cardData.winCard);
            } else {
                while(true) {
                    let cTmp = MahjongDataManage.getRandomCard();
                    if (!this.cardData.winCard.includes(cTmp)) {
                        card = cTmp;
                        break;
                    }
                }
            }
            let nodeItem = cc.instantiate(this.nodeItemComPrefab);
            this.nodeCombinationLayout.addChild(nodeItem);

            let script = nodeItem.getComponent(MahjongItemCom);
            script.setData(winPropInfo.sum, bWin, card);
            // script.setData(card);
        }

        // 海底捞月
        if (true) {

            let idx = data_control.randomNumInt(1, MahjongKind.WinProb.length-1);
            let winPropInfo = MahjongKind.WinProb[idx];
            let bWin = false;
            let card = 0;
            if (data_control.isHitProbability(MahjongKind.GeneralValue.HAI_DI_LAO_PROB)) {
                bWin = true;
                card = data_control.getRandArrItem(this.cardData.winCard);
            } else {
                while(true) {
                    let cTmp = MahjongDataManage.getRandomCard();
                    if (!this.cardData.winCard.includes(cTmp)) {
                        card = cTmp;
                        break;
                    }
                }
            }
            let nodeItem = cc.instantiate(this.nodeItemComPrefab);
            this.nodeCombinationLayout.addChild(nodeItem);
            
            let script = nodeItem.getComponent(MahjongItemCom);
            script.setData(winPropInfo.sum, bWin, card, true);
        }
        
    }

    /**
     * 生成牌
     * @param card 
     * @param parent 
     */
    generateBaseCard(card: number, parent: cc.Node) {
        let nodeItem = cc.instantiate(this.nodeItemPrefab);
        parent.addChild(nodeItem);

        let script = nodeItem.getComponent(MahjongItemBase);
        script.setData(card);
    }

    checkJudge(pos1: cc.Vec2, pos2: cc.Vec2) {
        this.checkJudgeLottery(pos1, pos2);
    }

    checkJudgeNode(pos: cc.Vec2) {
        this.checkJudgeLottery(pos);
    }

    checkJudgeLottery(pos1: cc.Vec2, pos2: cc.Vec2 = null) {
        if (this.bFinishShow) {
            return;
        }
        if (!this.bReferAreaShow) {
            let referArr = [this.nodeReferLayout1, this.nodeReferLayout2];
            let lenRefer = 0;
            for (let o of referArr) {
                let childrenRefer = o.children;
                lenRefer += childrenRefer.length;
                for (let i = 0; i < childrenRefer.length; i++) {
                    let childNode = childrenRefer[i];
                    let script = childNode.getComponent(MahjongItemBase);
                    if (pos2) {
                        if (script.checkJudge(pos1, pos2)) {
                            lenRefer--;
                        }
                    } else {
                        if (script.checkJudgeNode(pos1)) {
                            lenRefer--;
                        }
                    }
                }
            }
            if (lenRefer <= 0) {
                this.bReferAreaShow = true;
            }
        }

        let childrenCom = this.nodeCombinationLayout.children;
        let lenCom = childrenCom.length;
        for (let i = 0; i < childrenCom.length; i++) {
            let childNode = childrenCom[i];
            let script = childNode.getComponent(MahjongItemCom);
            if (script.isYetOpen()) {
                lenCom--;
            } else {
                if (pos2) {
                    if (script.checkJudge(pos1, pos2)) {
                        script.setYetOpen();
                        lenCom--;
                    }
                } else {
                    if (script.checkJudgeNode(pos1)) {
                        script.setYetOpen();
                        lenCom--;
                    }
                }
            }
            if (script.isYetOpen() && this.bReferAreaShow) {
                let multi = 1;
                if (script.isHaiDi()) {
                    let ctd = MahjongKind.CardTypeInfoArr[MahjongKind.CardType.HAI_DI_LAO];
                    multi = ctd.multipe;
                }
                let cardTypeData = MahjongKind.CardTypeInfoArr[this.cardType];
                script.showAward(cardTypeData.multipe * multi);
            }
        }

        if (lenCom <= 0 && this.bReferAreaShow) {
            this.bFinishShow = true;
            this.showAllMask();
        }   
    }

    // onClickBuy() {
    //     let cardData = MahjongDataManage.generateCardType(MahjongKind.CardType.QING_QI_DUI);
    //     cc.log('cardData.card',cardData.card)
    //     cc.log('cardData.winCard',cardData.winCard)
    // }
}
